// extracted by mini-css-extract-plugin
export default {"container":"Uj-z","blurb":"Vj-z","links":"Wj-z"};